import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  levels1: [],
  status: "idle",
  error: null,
};

export const levels1Slice = createSlice({
  name: "levels1",
  initialState,
  reducers: {
    levels1Requested: (state) => {
      state.status = "loading";
    },
    levels1RequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    levels1RequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.levels1 = action.payload;
    },
  },
});

export const {
  levels1Requested,
  levels1RequestFailed,
  levels1RequestSucceeded,
} = levels1Slice.actions;

export default levels1Slice.reducer;
